import React from 'react';

import {ACTION} from '../../../../constants';

import Button, { buttonType, buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

export default class ChangeStatus extends React.Component {
  render() {
    const { familyId, availableActions, performFamilyActionFunction, changeStatus } = this.props;
    if (!availableActions.includes(ACTION.APPROVE)) return null;

    return (
      <section className='scene_section detailsScene__change-status-section'>
        <header>Actions</header>
        <div className='detailsScene__change-status-buttons-wrapper'>
          <EditApplicationButton
            className='_height_40 _width_pc_100 _max_width_180 _margin_right_20'
            onClick={() => performFamilyActionFunction(ACTION.EDIT, familyId)}
          />
          <Button
            label='Approve'
            buttonClassName='_height_40 _width_120 _margin_right_20'
            onClick={() => {
              performFamilyActionFunction(ACTION.APPROVE, familyId).then(updatedData => changeStatus(updatedData));
            }}
            type={buttonType.primary}
            color={buttonColor.green}
          />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/ChangeStatus.jsx